import { isPolestar } from '../utils/globalContext';
import { getDictionaryByLocale as getPolestarDictionary } from './translations/Polestar';
import { getDictionaryByLocale as getVolvoDictionary } from './translations/Volvo';
import {
  locales as VolvoLocales,
  languageToLocale as languageToLocaleVolvo,
} from './translations/Volvo/locales';
import {
  locales as PolestarLocales,
  languageToLocale as languageToLocalePolestar,
} from './translations/Polestar/locales';

export const availableLocales = isPolestar ? PolestarLocales : VolvoLocales;
export const languageToLocale = isPolestar
  ? languageToLocalePolestar
  : languageToLocaleVolvo;

export const getDictionary = (locale) => {
  return isPolestar
    ? getPolestarDictionary(locale)
    : getVolvoDictionary(locale);
};
